<template>
    <div>
        <div layout="column" layout-align="start start" class="full-width mb20-pc px2-pc pb1-pc mb2-mobile px1-mobile bg-white">
            <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc">{{$t('params.users')}}
                <v-btn @click="displayFilters = !displayFilters" icon class="hidden-md-and-up ml-1"><i :class="['mdi', displayFilters ? 'mdi-filter-remove' : 'mdi-filter']" style="color: black"></i></v-btn>
            </div>
            <div v-if="!$vuetify.breakpoint. smAndDown || displayFilters" layout="row" layout-wrap layout-align="start center" class="full-width">
                <v-select
                    :label="$t('filters.status')"
                    :hint="$t('filters.status_hint')"
                    persistent-hint
                    solo v-model="filters.is_enabled"
                    :items="listStatus"
                    @change="fetch"
                    class="mr5-pc width-100-mobile"
                >
                </v-select>
                <v-text-field solo :label="$t('filters.keywords')" :hint="$t('filters.users_hint')" persistent-hint v-model="filters.keywords" @keyup.enter="fetch" class="ml5-pc mr5-pc width-100-mobile"></v-text-field>
                <v-btn depressed class="ml5-pc" color="secondary" @click="fetch" large>{{$t('filters.filter_btn')}}</v-btn>
                {{$t('_.or')}}
                <a href="#" class="ml-2 black--text" @click.prevent="resetFilters">{{$t('filters.reinit')}}</a>
            </div>
        </div>
        <div layout="column" layout-align="start start" class="full-width pt3-pc pb5-pc px2-pc pa1-mobile bg-white">
            <div class="font-weight-bold">
                <span class="secondary--text">{{users.length}}</span>&nbsp;
                <span v-if="users.length > 1">
                    <span class="text-lowercase">{{$t('params.users')}}</span>
                    {{$t('filters.match_pl')}} {{$t('filters.criteria')}}
                </span>
                <span v-else>
                    <span class="text-lowercase">{{$t('params.user')}}</span>
                    {{$t('filters.match')}} {{$t('filters.criteria')}}
                </span>
            </div>

            <div class="mt-1">
                <v-btn class="ml-0" flat outline color="secondary" :to="{name: 'admin-settings-users-edit', params: {id: 'new'}}">
                    <span style="text-transform: none">{{$t('params.add_user_btn')}}</span>
                </v-btn>
            </div>

            <v-data-table :headers="headers" :items="users"  :pagination.sync="pagination" class="full-width hidden-sm-and-down">
                <template slot="items" slot-scope="{ item }">
                    <td><v-icon :color="item.is_enabled ? 'success' : 'error'">mdi-checkbox-blank-circle-outline</v-icon></td>
                    <td>{{ item.firstname }}</td>
                    <td>{{ item.lastname }}</td>
                    <td class="break-word">{{ item.email }}</td>
                    <td layout="row">
                        <v-btn :title="$t('_.edit')" class="mx-0" icon :to="{name: 'admin-settings-users-edit', params: {id: item.id}}">
                            <v-icon color="secondary">mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn :title="item.is_enabled ? $t('_.disable') : $t('_.enable')" class="mx-0" icon @click="toggle(item)">
                            <v-icon color="secondary">{{ item.is_enabled ? 'mdi-lock-outline': 'mdi-lock-open-outline' }}</v-icon>
                        </v-btn>
                    </td>
                </template>
            </v-data-table>

            <v-list class="hidden-md-and-up full-width" two-line>
                <v-list-tile v-for="item in users" :key="item.id">
                    <v-list-tile-avatar style="min-width: 56px"><v-icon :class="{'circle-container': true, 'success': item.is_enabled, 'error': !item.is_enabled}" color="white">mdi-account</v-icon></v-list-tile-avatar>

                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.firstname }} {{ item.lastname }}</v-list-tile-title>
                        <v-list-tile-sub-title><a :href="`mailto:${item.email}}`" class="break-word">{{ item.email }}</a></v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action layout="row" layout-align="center center">
                        <v-btn :title="$t('_.edit')" class="mx-0" icon :to="{name: 'admin-settings-users-edit', params: {id: item.id}}"><v-icon color="secondary">mdi-pencil</v-icon></v-btn>
                        <v-btn :title="item.is_enabled ? $t('_.disable') : $t('_.enable')" class="mx-0" icon @click="toggle(item)">
                            <v-icon color="secondary">{{ item.is_enabled ? 'mdi-lock-outline': 'mdi-lock-open-outline' }}</v-icon>
                        </v-btn>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
        </div>
    </div>
</template>

<script>
    import Params from '~/api/params'
    import DeleteButton from "~/components/shared/DeleteButton.vue"

    export default {
        components: {DeleteButton},
        data () {
            return {
                pagination: {
                    rowsPerPage: 10,
                    descending: 0,
                    sortBy: 'firstname',
                },
                filters: {
                    keywords: null,
                    is_enabled: null,
                    sortBy: 'firstname'
                },
                users: [],
                displayFilters: false
            }
        },
        mounted () {
            this.fetch();
        },
        methods: {
            fetch () {
                Params.getList('users', this.filters).then(res => {
                    this.users = res.data;
                })
            },

            resetFilters () {
                this.filters = {keywords: null, is_enabled: null, sortBy: 'firstname'};
                this.fetch();
            },

            toggle (item) {
                if (item.is_enabled) {
                    Params.disable('users', item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(this.$t('params.user_disable'))
                    })
                } else {
                    Params.enable('users', item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(this.$t('params.user_enable'))
                    })
                }
            }
        },
        computed: {
            headers () {
                return [
                    { text: this.$t('filters.status'), value: 'is_enabled', width: "50px" },
                    { text: this.$t('users.firstname'), value: 'firstname' },
                    { text: this.$t('users.lastname'), value: 'lastname' },
                    { text: 'E-mail', value: 'email' },
                    { text: this.$t('_.actions'), sortable: false, width: "80px" }
                ]
            },
            listStatus () {
                return [
                    { value: null, text: this.$t('filters.status_all') },
                    { value: 1, text: this.$t('filters.status_enabled') },
                    { value: 0, text: this.$t('filters.status_disabled') }
                ]
            }
        }
    }
</script>